"use client";

import type { GtagConsent, GtagEvent } from "./types";

export function sendGTMEvent(event: GtagEvent) {
	if (!window?.gtag) return;
	window.gtag("event", event.action, {
		event_category: event.category,
		event_label: event.label,
		value: event.value,
	});
}

export function updateGTMConsent(consent: GtagConsent) {
	if (!window?.gtag) return;
	window.gtag("consent", "update", {
		ad_storage: consent,
		analytics_storage: consent,
		personalization_storage: consent,
		functionality_storage: consent,
		security_storage: consent,
		ad_user_data: consent,
		ad_personalization: consent,
	});
}

export function trackGTMPageView(url: string, gtmId: string) {
	if (!window?.gtag) return;
	window.gtag("config", gtmId, { page_path: url });
}

export function trackGTMConversion(value: number) {
	// Custom event trigger created in GTM
	window.dataLayer?.push({
		event: "subscription_created",
		value,
	});

	// Event trigger created in Google Ads directly
	if (!window?.gtag) return;
	window.gtag("event", "conversion", {
		send_to: "AW-16632067118/pFigCPmkxqkaEK7o5Po9",
		value,
		currency: "USD",
		transaction_id: "",
	});
}

export function trackGTMSignUp() {
	// Custom event trigger created in GTM
	window.dataLayer?.push({
		event: "sign_up",
	});
}
